module.exports = __webpack_public_path__ + "static/gallery1-042c49a619e26a3b4ad7087d4f7906cc.jpg";